import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { useDispatch } from "react-redux";

import {
  closeProductModal,
  refreshProductList,
} from "../../redux/features/productModalSlice";
import { successToast, errorToast } from "../../Utils/toast";

function DeleteModal({
  title,
  message,
  deleteFunction,
  id,
  onSuccess
}) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

const handleDelete = async () => {
  try {
    setLoading(true);

    const res = await deleteFunction({ id });
console.log("Response:", res);
console.log("Success:", res?.success);
console.log("Type:", typeof res?.success);
    if (res?.success) {
      successToast(res.message);
      dispatch(refreshProductList());      
      dispatch(closeProductModal());       

      onSuccess?.();
    } else {
      errorToast(res?.message || "Delete Failed");
    }

  } catch (error) {
    console.log(error);
    errorToast(error?.response?.data?.message || "Delete Failed");
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <div className="custom-modal-body text-center">

        <div className="model-custum">
          <div className="delete-icon">
            <FaTrash />
          </div>

          <h3>{title}</h3>
          <p className="delete-text">{message}</p>
        </div>

      </div>

      <div className="modal-btn-group justify-content-center">

        <button
          className="delete-btn"
          onClick={() => dispatch(closeProductModal())}
        >
          Cancel
        </button>

        <button
          className="add-btn"
          onClick={handleDelete}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Yes Delete"}
        </button>

      </div>
    </>
  );
}

export default DeleteModal;